import {register} from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';

const selectors = {
  imageTitle: '[data-page-image-title]',
  defaultTitle: '[data-page-default-title]',
  noTitleClass: 'has-no-title',
};

class Page {
  constructor(el) {
    this.container = el;
    this.imageTitle = this.container.querySelector(selectors.imageTitle);
    if (!this.imageTitle) {
      this.container.parentElement.classList.add(selectors.noTitleClass);
    }
  }
}

const pageSection = {
  onLoad() {
    new Page(this.container);
  },
};

register('page', [pageSection, parallaxImage]);
